export default function () {
    jQuery('.js-header--search').on('click', function () {
        jQuery('.js-header--search-wrapper').addClass('search-hidden');
        jQuery('.js-search--container').removeClass('hidden');

        jQuery('.js-mega-menu--toggle').removeClass('active');
        jQuery('header').addClass('mega-menu-opened');
        jQuery('.js-mega-menu--container').hide(300);

        jQuery('#searchform input').focus();
    });

    jQuery('.js-search--confirm').on('click', function () {
        jQuery(this).siblings('form').submit();
    });

    jQuery('.js-search--close').on('click', function () {
        jQuery('.js-header--search-wrapper').removeClass('search-hidden');
        jQuery('.js-search--container').addClass('hidden');
    });
}
